import { FormattedMessage } from 'react-intl';

import { TimeZoneChip, TimeZoneChipZone } from '@/components/ui/time-zone-chip';

/** The All Campaigns count bar's note that each campaign counts in its opening's zone. */
export function CampaignsTimeZoneChip() {
  return (
    <TimeZoneChip
      withInfoIcon
      tooltipTitle={
        <FormattedMessage
          defaultMessage="How totals are counted"
          description="Title of the tooltip on the All Campaigns time zone chip"
        />
      }
      tooltipBody={
        <p>
          <FormattedMessage
            defaultMessage="Totals add up each campaign’s days in its opening’s time zone. They don’t change with your time zone."
            description="Tooltip on the All Campaigns time zone chip: totals add up each campaign's days in its opening's time zone, the same for every viewer"
          />
        </p>
      }
    >
      <FormattedMessage
        defaultMessage="Each campaign counts in <zone>its opening’s time zone</zone>"
        description="Chip in the All Campaigns count bar: every campaign counts in its opening's time zone"
        values={{
          zone: chunks => <TimeZoneChipZone>{chunks}</TimeZoneChipZone>,
        }}
      />
    </TimeZoneChip>
  );
}
